// Precipitation, drawn over the scene so it reads as being between you and the
// fight rather than painted on the back wall.

import { ctx } from '../canvas.js';
import { state } from '../state.js';
import { mods } from '../modes.js';

/** Rain streaks lean with the wind, which is the only warning you get. */
const RAIN_LEAN = 0.5;

export function drawWeather() {
  const kind = mods().precipitation;
  if (!kind) return;

  const snow = kind === 'snow';

  ctx.save();
  ctx.lineCap = 'round';

  if (snow) {
    ctx.fillStyle = '#e8f4ff';
    for (const d of state.precip) {
      ctx.globalAlpha = 0.25 + (d.z / 10) * 0.55;
      ctx.beginPath();
      ctx.arc(d.x, d.y, d.z / 5, 0, Math.PI * 2);
      ctx.fill();
    }
  } else {
    ctx.strokeStyle = '#a9d4ff';
    ctx.lineWidth = 1;
    for (const d of state.precip) {
      const len = 5 + (d.z / 10) * 9;
      ctx.globalAlpha = 0.2 + (d.z / 10) * 0.4;
      ctx.beginPath();
      ctx.moveTo(d.x, d.y);
      ctx.lineTo(d.x - state.wind * RAIN_LEAN, d.y + len);
      ctx.stroke();
    }
  }

  ctx.restore();
}
